import React from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import logo from '../../assets/images/logo.png';
import { Mail, Phone, MapPin } from 'lucide-react';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="cb-footer">
            <div className="cb-footer-ambient"></div>
            <div className="cb-footer-ambient-2"></div>
            <div className="container">
                <div className="cb-footer-grid">
                    <div className="cb-footer-brand-col">
                        <HashLink to="/#home" className="cb-footer-logo-link" aria-label="ChemBioAI Home">
                            <img src={logo} alt="ChemBioAI Logo" className="cb-footer-logo" />
                        </HashLink>
                        <p className="cb-footer-tagline">
                            A dynamic open-source research community committed to advancing scientific frontiers by seamlessly blending Chemistry, Biology, and Artificial Intelligence.
                        </p>
                    </div>

                    <div className="cb-footer-nav-col">
                        <span className="cb-footer-col-num">01</span>
                        <h4 className="cb-footer-heading">Quick Links</h4>
                        <ul className="cb-footer-links">
                            <li><HashLink to="/#home" className="cb-footer-link">Home</HashLink></li>
                            <li><HashLink to="/#about" className="cb-footer-link">About Us</HashLink></li>
                            <li><HashLink to="/#services" className="cb-footer-link">Key Tenets</HashLink></li>
                            <li><HashLink to="/#why" className="cb-footer-link">Why Us</HashLink></li>
                            <li><HashLink to="/#vision" className="cb-footer-link">Vision & Mission</HashLink></li>
                            <li><Link to="/agent-scientist" className="cb-footer-link" onClick={() => window.scrollTo(0, 0)}>Agent Scientist</Link></li>
                            <li><Link to="/events" className="cb-footer-link" onClick={() => window.scrollTo(0, 0)}>Events &amp; Hackathons</Link></li>
                            <li><HashLink to="/#contact" className="cb-footer-link">Contact</HashLink></li>
                        </ul>
                    </div>

                    <div className="cb-footer-nav-col">
                        <span className="cb-footer-col-num">02</span>
                        <h4 className="cb-footer-heading">Connect</h4>
                        <div className="cb-footer-contact-info">
                            <a href="mailto:contact@chembioai.org" className="cb-footer-contact-item">
                                <span className="cb-contact-mini-icon"><Mail size={14} strokeWidth={2.2} /></span>
                                <span>contact@chembioai.org</span>
                            </a>
                            <a href="tel:+919498866488" className="cb-footer-contact-item">
                                <span className="cb-contact-mini-icon"><Phone size={14} strokeWidth={2.2} /></span>
                                <span>+91 9498866488</span>
                            </a>
                            <div className="cb-footer-contact-item">
                                <span className="cb-contact-mini-icon"><MapPin size={14} strokeWidth={2.2} /></span>
                                <span>Kondapur, Hyderabad, TS</span>
                            </div>
                        </div>

                        <a 
                            href="https://discord.gg/nGtFAR3hwn" 
                            target="_blank" 
                            rel="noreferrer" 
                            className="cb-footer-cta-discord"
                        >
                            <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                                <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028c.462-.63.874-1.295 1.226-1.994.021-.041.001-.09-.041-.106a13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.929 1.793 8.18 1.793 12.061 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.894.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.028zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
                            </svg>
                            <span>Join Discord</span>
                        </a>
                    </div>
                </div>

                <div className="cb-footer-watermark-wrap" aria-hidden="true">
                    <span className="cb-footer-watermark-text">CHEMBIOAI</span>
                </div>

                <div className="cb-footer-bottom">
                    <p className="cb-footer-copy">
                        © ChembioAI 2026 All rights reserved.
                    </p>

                    <div className="cb-footer-socials">
                        <a 
                            className="cb-footer-social-btn" 
                            href="https://www.linkedin.com/company/chembio-ai/" 
                            target="_blank" 
                            rel="noreferrer"
                            aria-label="LinkedIn"
                        >
                            <svg viewBox="0 0 24 24" fill="currentColor">
                                <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.28 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.75M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z"/>
                            </svg>
                        </a>
                        <a 
                            className="cb-footer-social-btn" 
                            href="https://x.com/chembio_ai" 
                            target="_blank" 
                            rel="noreferrer"
                            aria-label="Twitter X"
                        >
                            <svg viewBox="0 0 24 24" fill="currentColor">
                                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;